import type { OrbitalElements } from "../math/orbital_elements";
import { Vector3d } from "../math/vector3d";
import type { SpacecraftState } from "../spacecraft/spacecraft_state";

/**
 * Complete simulation state at any point in time.
 */
export class SimulationState {
  spacecraft: SpacecraftState;
  currentSOIBody: string;
  currentOrbit: OrbitalElements;
  startTimeJD: number;
  /** Sum of all maneuver magnitudes in m/s */
  totalDeltaVUsed: number = 0;

  /** Trajectory history for trail rendering */
  trajectoryHistory: Vector3d[] = [];
  maxTrajectoryPoints: number = 1000;

  /** Previous true anomaly for apsides detection */
  previousTrueAnomaly: number = 0;

  constructor(init: {
    spacecraft: SpacecraftState;
    currentSOIBody: string;
    currentOrbit: OrbitalElements;
    startTimeJD: number;
  }) {
    this.spacecraft = init.spacecraft;
    this.currentSOIBody = init.currentSOIBody;
    this.currentOrbit = init.currentOrbit;
    this.startTimeJD = init.startTimeJD;
  }

  /** Record current position to trajectory history. */
  recordTrajectoryPoint(position: Vector3d): void {
    this.trajectoryHistory.push(position);
    if (this.trajectoryHistory.length > this.maxTrajectoryPoints) {
      this.trajectoryHistory.shift();
    }
  }
}
